import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { AdminHeader } from '~/layouts/AdminHeader';
import { routePath } from '~/utils/constants';
import {
  StyledContentContainer,
  StyledMainContainer,
} from './AdminLayout.style';
import { useAdminAuthGuard } from '~/utils/hook/useAdminAuthGuard';
import { AdminReloginDialog } from '~/components/Global/Dialog/AdminReloginDialog';

type TLayoutProps = {
  children: ReactNode;
};

export const AdminLayout = ({ children }: TLayoutProps) => {
  const { pathname } = useLocation();
  useAdminAuthGuard({ jumpAwayFromLoginWhenAuthed: true });

  return (
    <StyledMainContainer>
      {pathname === routePath.admin && <AdminHeader />}
      <StyledContentContainer>{children}</StyledContentContainer>
      <AdminReloginDialog />
    </StyledMainContainer>
  );
};
